import { render, staticRenderFns } from "./DatatablesMaterial.vue?vue&type=template&id=69d05676&scoped=true"
import script from "./DatatablesMaterial.vue?vue&type=script&lang=js"
export * from "./DatatablesMaterial.vue?vue&type=script&lang=js"
import style0 from "./DatatablesMaterial.vue?vue&type=style&index=0&id=69d05676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d05676",
  null
  
)

export default component.exports